import React from 'react';
import InnerBlock from '../../shared/web/layout/InnerBlock';
import { ProjectTypesTabs } from '../shared/ProjectTypesTabs/ProjectTypesTabs';
import { ProjectType } from 'nekst-api';
import PortalConfigurationForm from './DefaultConfiguration/PortalConfigurationForm';
import { TeamSetupAreaAliasDropdown } from 'features/tasks-forms';
import useSettingsNavigator from '../settingsNavigator';
import { useParams } from 'react-router-dom';
import SetupAreasRequiredWrapper from '../markets/SetupAreasRequiredWrapper';
import { Separator } from 'features/nekst-widgets';
import DefaultPortalNotesList from './DefaultNotes/DefaultPortalNotesList';

import styles from './ClientPortalConfigurationPage.module.scss';

function NewPortalConfigurationPageContent() {

  const settingNavigator = useSettingsNavigator();

  const {
    setupAreaId,
    projectType: projectTypeParam
  } = useParams();

  const openPage = (newSetupAreaId: string, newProjectType: ProjectType) => {
    settingNavigator.openNewClientPortalConfigurationPage(
      newSetupAreaId,
      newProjectType
    );
  };

  const projectType = projectTypeParam ? projectTypeParam.toUpperCase() as ProjectType : ProjectType.PENDING_BUYER;

  return (
    <>
      <TeamSetupAreaAliasDropdown
        label="Choose Market"
        source="setupAreaId"
        onChangeCallback={(event) => {
          openPage(event.setupAreaId,
            projectTypeParam ? projectTypeParam.toUpperCase() as ProjectType : ProjectType.PENDING_BUYER
          );
        }}
        value={setupAreaId}
      />
      <ProjectTypesTabs
        setProjectType={(newProjectType) => {
          if (setupAreaId) {
            openPage(setupAreaId, newProjectType);
          }
        }}
        projectType={projectType}
        className={styles.dropdown}
      />
      <PortalConfigurationForm projectType={projectType} setupAreaId={setupAreaId} />
      <Separator marginSize="big" />
      <DefaultPortalNotesList projectType={projectType} />
    </>
  )
}

export function NewPortalConfigurationPage() {
  return (
    <InnerBlock title="Client Portal Configuration">
      <SetupAreasRequiredWrapper>
        <NewPortalConfigurationPageContent />
      </SetupAreasRequiredWrapper>

    </InnerBlock>
  );
}
